import {
  FETCH_PARKING_LOTS,
  FETCH_PARKING_LOTS_SUCCESS,
  FETCH_PARKING_LOTS_ERROR,
  FETCH_PARKING_LOT_BY_ID,
  FETCH_PARKING_LOT_BY_ID_SUCCESS,
  FETCH_PARKING_LOT_BY_ID_ERROR,
  CREATE_PARKING_LOT,
  CREATE_PARKING_LOT_SUCCESS,
  CREATE_PARKING_LOT_ERROR,
  UPDATE_PARKING_LOT,
  UPDATE_PARKING_LOT_SUCCESS,
  UPDATE_PARKING_LOT_ERROR,
  DELETE_PARKING_LOT,
  DELETE_PARKING_LOT_SUCCESS,
  DELETE_PARKING_LOT_ERROR,
  ADD_PERMIT_TYPE,
  ADD_PERMIT_TYPE_SUCCESS,
  ADD_PERMIT_TYPE_ERROR,
  UPDATE_PERMIT_TYPE,
  UPDATE_PERMIT_TYPE_SUCCESS,
  UPDATE_PERMIT_TYPE_ERROR,
  DELETE_PERMIT_TYPE,
  DELETE_PERMIT_TYPE_SUCCESS,
  DELETE_PERMIT_TYPE_ERROR,
  ADD_ZONE,
  ADD_ZONE_SUCCESS,
  ADD_ZONE_ERROR,
  UPDATE_ZONE,
  UPDATE_ZONE_SUCCESS,
  UPDATE_ZONE_ERROR,
  DELETE_ZONE,
  DELETE_ZONE_SUCCESS,
  DELETE_ZONE_ERROR,
  FETCH_ZONE_PERMIT_TYPES,
  FETCH_ZONE_PERMIT_TYPES_SUCCESS,
  FETCH_ZONE_PERMIT_TYPES_ERROR,
  LINK_PERMIT_TYPE_TO_ZONE,
  LINK_PERMIT_TYPE_TO_ZONE_SUCCESS,
  LINK_PERMIT_TYPE_TO_ZONE_ERROR,
  UPDATE_ZONE_PERMIT_TYPE_LINK,
  UPDATE_ZONE_PERMIT_TYPE_LINK_SUCCESS,
  UPDATE_ZONE_PERMIT_TYPE_LINK_ERROR,
  UNLINK_PERMIT_TYPE_FROM_ZONE,
  UNLINK_PERMIT_TYPE_FROM_ZONE_SUCCESS,
  UNLINK_PERMIT_TYPE_FROM_ZONE_ERROR,
} from './types';

const initialState = {
  lots: [],
  selectedLot: null,
  zonePermitTypes: [],
  loading: {
    fetch: false,
    fetchById: false,
    create: false,
    update: false,
    delete: false,
    addPermitType: false,
    updatePermitType: false,
    deletePermitType: false,
    addZone: false,
    updateZone: false,
    deleteZone: false,
    fetchZonePermitTypes: false,
    linkPermitType: false,
    updateZonePermitTypeLink: false,
    unlinkPermitType: false,
  },
  error: {
    fetch: null,
    fetchById: null,
    create: null,
    update: null,
    delete: null,
    addPermitType: null,
    updatePermitType: null,
    deletePermitType: null,
    addZone: null,
    updateZone: null,
    deleteZone: null,
    fetchZonePermitTypes: null,
    linkPermitType: null,
    updateZonePermitTypeLink: null,
    unlinkPermitType: null,
  },
};

const parkingLotsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    // Fetch all lots
    case FETCH_PARKING_LOTS:
      return {
        ...state,
        loading: { ...state.loading, fetch: true },
        error: { ...state.error, fetch: null },
      };
    case FETCH_PARKING_LOTS_SUCCESS:
      return {
        ...state,
        lots: payload,
        loading: { ...state.loading, fetch: false },
      };
    case FETCH_PARKING_LOTS_ERROR:
      return {
        ...state,
        loading: { ...state.loading, fetch: false },
        error: { ...state.error, fetch: 'Failed to fetch parking lots' },
      };

    // Fetch lot by ID
    case FETCH_PARKING_LOT_BY_ID:
      return {
        ...state,
        loading: { ...state.loading, fetchById: true },
        error: { ...state.error, fetchById: null },
      };
    case FETCH_PARKING_LOT_BY_ID_SUCCESS:
      return {
        ...state,
        selectedLot: payload,
        loading: { ...state.loading, fetchById: false },
      };
    case FETCH_PARKING_LOT_BY_ID_ERROR:
      return {
        ...state,
        loading: { ...state.loading, fetchById: false },
        error: { ...state.error, fetchById: 'Failed to fetch parking lot' },
      };

    // Create lot
    case CREATE_PARKING_LOT:
      return {
        ...state,
        loading: { ...state.loading, create: true },
        error: { ...state.error, create: null },
      };
    case CREATE_PARKING_LOT_SUCCESS:
      return {
        ...state,
        lots: [...state.lots, payload],
        selectedLot: payload,
        loading: { ...state.loading, create: false },
      };
    case CREATE_PARKING_LOT_ERROR:
      return {
        ...state,
        loading: { ...state.loading, create: false },
        error: { ...state.error, create: 'Failed to create parking lot' },
      };

    // Update lot
    case UPDATE_PARKING_LOT:
      return {
        ...state,
        loading: { ...state.loading, update: true },
        error: { ...state.error, update: null },
      };
    case UPDATE_PARKING_LOT_SUCCESS:
      return {
        ...state,
        lots: state.lots.map((lot) => (lot.parkingLotId === payload.parkingLotId ? payload : lot)),
        selectedLot: payload,
        loading: { ...state.loading, update: false },
      };
    case UPDATE_PARKING_LOT_ERROR:
      return {
        ...state,
        loading: { ...state.loading, update: false },
        error: { ...state.error, update: 'Failed to update parking lot' },
      };

    // Delete lot
    case DELETE_PARKING_LOT:
      return {
        ...state,
        loading: { ...state.loading, delete: true },
        error: { ...state.error, delete: null },
      };
    case DELETE_PARKING_LOT_SUCCESS:
      return {
        ...state,
        lots: state.lots.filter((lot) => lot.parkingLotId !== payload),
        selectedLot: state.selectedLot?.parkingLotId === payload ? null : state.selectedLot,
        loading: { ...state.loading, delete: false },
      };
    case DELETE_PARKING_LOT_ERROR:
      return {
        ...state,
        loading: { ...state.loading, delete: false },
        error: { ...state.error, delete: 'Failed to delete parking lot' },
      };

    // Add permit type
    case ADD_PERMIT_TYPE:
      return {
        ...state,
        loading: { ...state.loading, addPermitType: true },
        error: { ...state.error, addPermitType: null },
      };
    case ADD_PERMIT_TYPE_SUCCESS:
      return {
        ...state,
        selectedLot: {
          ...state.selectedLot,
          permitTypes: [...(state.selectedLot?.permitTypes || []), payload],
        },
        loading: { ...state.loading, addPermitType: false },
      };
    case ADD_PERMIT_TYPE_ERROR:
      return {
        ...state,
        loading: { ...state.loading, addPermitType: false },
        error: { ...state.error, addPermitType: 'Failed to add permit type' },
      };

    // Update permit type
    case UPDATE_PERMIT_TYPE:
      return {
        ...state,
        loading: { ...state.loading, updatePermitType: true },
        error: { ...state.error, updatePermitType: null },
      };
    case UPDATE_PERMIT_TYPE_SUCCESS:
      return {
        ...state,
        selectedLot: {
          ...state.selectedLot,
          permitTypes: state.selectedLot?.permitTypes?.map((pt) =>
            pt.permitTypeId === payload.permitTypeId ? payload : pt
          ) || [],
        },
        loading: { ...state.loading, updatePermitType: false },
      };
    case UPDATE_PERMIT_TYPE_ERROR:
      return {
        ...state,
        loading: { ...state.loading, updatePermitType: false },
        error: { ...state.error, updatePermitType: 'Failed to update permit type' },
      };

    // Delete permit type
    case DELETE_PERMIT_TYPE:
      return {
        ...state,
        loading: { ...state.loading, deletePermitType: true },
        error: { ...state.error, deletePermitType: null },
      };
    case DELETE_PERMIT_TYPE_SUCCESS:
      return {
        ...state,
        selectedLot: {
          ...state.selectedLot,
          permitTypes: state.selectedLot?.permitTypes?.filter(
            (pt) => pt.permitTypeId !== payload.permitTypeId
          ) || [],
        },
        loading: { ...state.loading, deletePermitType: false },
      };
    case DELETE_PERMIT_TYPE_ERROR:
      return {
        ...state,
        loading: { ...state.loading, deletePermitType: false },
        error: { ...state.error, deletePermitType: 'Failed to delete permit type' },
      };

    // Add zone
    case ADD_ZONE:
      return {
        ...state,
        loading: { ...state.loading, addZone: true },
        error: { ...state.error, addZone: null },
      };
    case ADD_ZONE_SUCCESS:
      return {
        ...state,
        selectedLot: {
          ...state.selectedLot,
          zones: [...(state.selectedLot?.zones || []), payload],
        },
        loading: { ...state.loading, addZone: false },
      };
    case ADD_ZONE_ERROR:
      return {
        ...state,
        loading: { ...state.loading, addZone: false },
        error: { ...state.error, addZone: 'Failed to add zone' },
      };

    // Update zone
    case UPDATE_ZONE:
      return {
        ...state,
        loading: { ...state.loading, updateZone: true },
        error: { ...state.error, updateZone: null },
      };
    case UPDATE_ZONE_SUCCESS:
      return {
        ...state,
        selectedLot: {
          ...state.selectedLot,
          zones: state.selectedLot?.zones?.map((z) =>
            z.zoneId === payload.zoneId ? payload : z
          ) || [],
        },
        loading: { ...state.loading, updateZone: false },
      };
    case UPDATE_ZONE_ERROR:
      return {
        ...state,
        loading: { ...state.loading, updateZone: false },
        error: { ...state.error, updateZone: 'Failed to update zone' },
      };

    // Delete zone
    case DELETE_ZONE:
      return {
        ...state,
        loading: { ...state.loading, deleteZone: true },
        error: { ...state.error, deleteZone: null },
      };
    case DELETE_ZONE_SUCCESS:
      return {
        ...state,
        selectedLot: {
          ...state.selectedLot,
          zones: state.selectedLot?.zones?.filter(
            (z) => z.zoneId !== payload.zoneId
          ) || [],
        },
        loading: { ...state.loading, deleteZone: false },
      };
    case DELETE_ZONE_ERROR:
      return {
        ...state,
        loading: { ...state.loading, deleteZone: false },
        error: { ...state.error, deleteZone: 'Failed to delete zone' },
      };

    // Fetch zone permit types
    case FETCH_ZONE_PERMIT_TYPES:
      return {
        ...state,
        loading: { ...state.loading, fetchZonePermitTypes: true },
        error: { ...state.error, fetchZonePermitTypes: null },
      };
    case FETCH_ZONE_PERMIT_TYPES_SUCCESS:
      return {
        ...state,
        zonePermitTypes: payload,
        loading: { ...state.loading, fetchZonePermitTypes: false },
      };
    case FETCH_ZONE_PERMIT_TYPES_ERROR:
      return {
        ...state,
        loading: { ...state.loading, fetchZonePermitTypes: false },
        error: { ...state.error, fetchZonePermitTypes: 'Failed to fetch zone permit types' },
      };

    // Link permit type to zone
    case LINK_PERMIT_TYPE_TO_ZONE:
      return {
        ...state,
        loading: { ...state.loading, linkPermitType: true },
        error: { ...state.error, linkPermitType: null },
      };
    case LINK_PERMIT_TYPE_TO_ZONE_SUCCESS:
      return {
        ...state,
        zonePermitTypes: [...state.zonePermitTypes, payload],
        loading: { ...state.loading, linkPermitType: false },
      };
    case LINK_PERMIT_TYPE_TO_ZONE_ERROR:
      return {
        ...state,
        loading: { ...state.loading, linkPermitType: false },
        error: { ...state.error, linkPermitType: 'Failed to link permit type to zone' },
      };

    // Update zone permit type link
    case UPDATE_ZONE_PERMIT_TYPE_LINK:
      return {
        ...state,
        loading: { ...state.loading, updateZonePermitTypeLink: true },
        error: { ...state.error, updateZonePermitTypeLink: null },
      };
    case UPDATE_ZONE_PERMIT_TYPE_LINK_SUCCESS:
      return {
        ...state,
        zonePermitTypes: state.zonePermitTypes.map((link) =>
          link.parkingLotZonePermitTypeID === payload.parkingLotZonePermitTypeID
            ? payload
            : link
        ),
        loading: { ...state.loading, updateZonePermitTypeLink: false },
      };
    case UPDATE_ZONE_PERMIT_TYPE_LINK_ERROR:
      return {
        ...state,
        loading: { ...state.loading, updateZonePermitTypeLink: false },
        error: { ...state.error, updateZonePermitTypeLink: 'Failed to update zone permit type link' },
      };

    // Unlink permit type from zone
    case UNLINK_PERMIT_TYPE_FROM_ZONE:
      return {
        ...state,
        loading: { ...state.loading, unlinkPermitType: true },
        error: { ...state.error, unlinkPermitType: null },
      };
    case UNLINK_PERMIT_TYPE_FROM_ZONE_SUCCESS:
      return {
        ...state,
        zonePermitTypes: state.zonePermitTypes.filter(
          (link) => link.parkingLotZonePermitTypeID !== payload
        ),
        loading: { ...state.loading, unlinkPermitType: false },
      };
    case UNLINK_PERMIT_TYPE_FROM_ZONE_ERROR:
      return {
        ...state,
        loading: { ...state.loading, unlinkPermitType: false },
        error: { ...state.error, unlinkPermitType: 'Failed to unlink permit type from zone' },
      };

    default:
      return state;
  }
};

export default parkingLotsReducer;
